import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";
import VueScrollTo from "vue-scrollto";
//import LoadScript from "vue-plugin-load-script";
import {i18n} from "./plugins/i18n";




Vue.config.productionTip = false

Vue.prototype.$mySite = {
  title: "CyberFoxGuard.com",
  url: "https://cyberfoxguard.com",
  image: "https://cyberfoxguard.com/share/share.jpg",
  api: "https://cyberfoxguard.com/apiweb/v1/"
};

axios.defaults.baseURL = "https://cyberfoxguard.com/apiweb/v1/";

Vue.use(VueAxios, axios);
Vue.use(Buefy, {
  defaultIconPack: "synthosm",
  //defaultIconPack: "syntho",
});
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
//Vue.use(VueScrollTo);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
//Vue.use(LoadScript);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
